<ng-container *ngIf="constant.IsVerified  && !constant.isLobbyShow">
  <ng-container *ngIf="(constant.isLobbyShowLive !== false) && (constant.isLobbyShowVirtual !== false)">
    <!-- *ngIf="constant?.tmpGameList && constant?.tmpGameList.length > 0" -->
    <main class="supernova-lobby">
      <div class="lobby">
        <div class="container-fluid cb-container-fluid cb-animation-container">
          <!-- <div class="container-fluid"> -->
          <div class="row">
            <div class="col-md-12 p-0">
              <!-- nav -->
              <ul class=" nav-tabs m-auto" role="tablist" id="scroll-menu">
                <li class="" role="presentation">
                  <a href="javascript:void(0);" style="text-decoration: none;" data-mdb-toggle="tab"
                    (click)="gameFilterList(fiterType.All)" [ngClass]="selectedfiterType===fiterType.All ? 'active':''">
                    {{ 'All' | translate }} </a>
                </li>
                <li role="presentation" *ngIf="GameTypePermission('Live')">
                  <a href="javascript:void(0);" style="text-decoration: none;" data-mdb-toggle="tab"
                    (click)="gameFilterList(fiterType.LiveGame)"
                    [ngClass]="selectedfiterType===fiterType.LiveGame ? 'active':''"> {{ 'Live' | translate }}
                  </a>
                </li>
                <li role="presentation" *ngIf="GameTypePermission('RNG')">
                  <a href="javascript:void(0);" style="text-decoration: none;" data-mdb-toggle="tab"
                    (click)="gameFilterList(fiterType.VirtualGame)"
                    [ngClass]="selectedfiterType==fiterType.VirtualGame ? 'active':''">
                    {{ 'RNG' | translate }}
                  </a>
                </li>
                <li role="presentation" *ngIf="GameTypePermission('Widget')">
                  <a href="javascript:void(0);" style="text-decoration: none;" data-mdb-toggle="tab"
                    (click)="gameFilterList(fiterType.WidGetGame)"
                    [ngClass]="selectedfiterType==fiterType.WidGetGame ? 'active':''">
                    {{ 'Widget' | translate }}
                  </a>
                </li>
              </ul>
              <div class="tab-content">
                <div class="tab-pane active" id="tab1">
                  <div class="container-fluid">
                    <div class="col-12 col-sm-12 p-0 portfolio" [hidden]="selectedfiterType !== fiterType.All">

                      <!-- <div class="row" *ngIf="constant.FavoriteGames.length > 0">
                        <p class="col-12 p-0 order-title">
                          <span class="order-name">Favorite Games</span>
                          <span class="see-all cursor-pointer" (click)="SeelAll(order)"> {{('SeeAll' | translate) }}
                            <span class="see-all-arrow"> {{'>'}} </span>
                          </span>
                        </p>
                        <div class="grid p-0 row">
                          <swiper [config]="config">
                            <ng-container *ngFor="let game of constant.FavoriteGames;let i=index">
                              <div class="swiper-slide effect-lexidiv" [value]="game.GameCode">
                                <figure class="effect-lexi"
                                  [style.backgroundImage]="'url('+ game.ImagePath +'),url(https://images.supernowa.net/Document/123/SN1.gif)'"
                                  [attr.title]="game.Name" [attr.alt]="game.Name">
                                  <figcaption>
                                    <p> <a class="play-now" (click)="selectedfiterType===fiterType.WidGetGame? getGameUrl(game,0): NavigatoToGame(game,i)">{{'PlayNow' | translate}}</a> </p>
                                  </figcaption>
                                  <h4 class="d-flex justify-content-evenly last-result"><a *ngFor="let count of array10">{{count}}</a> </h4>
                                </figure>
                                <p class="game-name-bottom">{{game.GameCode?translateService.instant(game.GameCode) : ''}}
                                  <a (click)="fav(game, false)" *ngIf="CheckFevGame(game.GameCode.trim())">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="red"><path d="M12 4.435c-1.989-5.399-12-4.597-12 3.568 0 4.068 3.06 9.481 12 14.997 8.94-5.516 12-10.929 12-14.997 0-8.118-10-8.999-12-3.568z"/></svg>
                                  </a>
                                  <a (click)="fav(game, true)" *ngIf="!CheckFevGame(game.GameCode.trim())">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="white"><path d="M12 9.229c.234-1.12 1.547-6.229 5.382-6.229 2.22 0 4.618 1.551 4.618 5.003 0 3.907-3.627 8.47-10 12.629-6.373-4.159-10-8.722-10-12.629 0-3.484 2.369-5.005 4.577-5.005 3.923 0 5.145 5.126 5.423 6.231zm-12-1.226c0 4.068 3.06 9.481 12 14.997 8.94-5.516 12-10.929 12-14.997 0-7.962-9.648-9.028-12-3.737-2.338-5.262-12-4.27-12 3.737z"/></svg>
                                  </a>
                                </p>
                              </div>
                            </ng-container>
                          </swiper>
                        </div>
                      </div> -->
                      <ng-container *ngFor="let order of constant.OrderViewGame | keyvalue : OrderBy; let i = index">
                        <div class="row" *ngIf="order.value.length > 0">
                          <p class="col-12 p-0 order-title">
                            <span class="order-name">{{ order.key?translateService.instant(order.key) : order.key}}
                            </span>
                            <span class="see-all cursor-pointer" (click)="SeelAll(order)"> {{('SeeAll' | translate) }}
                              <span class="see-all-arrow"> {{'>'}} </span>
                            </span>
                          </p>
                          <div class="grid p-0 row">
                            <swiper [config]="config">
                              <ng-container *ngFor="let game of order.value;let i=index">
                                <div class="swiper-slide effect-lexidiv" [value]="game.GameCode">
                                  <!--  (click)="checkGameStatus(game,i)" -->
                                  <figure class="effect-lexi"
                                    [style.backgroundImage]="'url('+ game.ImagePath +'),url(https://images.supernowa.net/Document/123/SN1.gif)'"
                                    [attr.title]="game.Name" [attr.alt]="game.Name">
                                    <!-- <figcaption>
                                      <p> <a class="play-now" (click)="selectedfiterType===fiterType.WidGetGame? getGameUrl(game,0): NavigatoToGame(game,i)">{{'PlayNow' | translate}}</a> </p>
                                    </figcaption> -->
                                  </figure>
                                  <a class="play-now"
                                    (click)="selectedfiterType===fiterType.WidGetGame? getGameUrl(game,0): NavigatoToGame(game,i)">{{'PlayNow'
                                    | translate}}</a>
                                  <h4 class="d-flex justify-content-evenly last-result"
                                    *ngIf="game.GameResult !==  undefined && game.GameResult !== null && game.GameResult.length > 0 ">
                                    <ng-container *ngFor="let result of game.GameResult;let i = index;">
                                      <a class="col" *ngIf="CheckGameResult(game.GameCode.trim(),i)">
                                        {{WinnerName(result, game.GameCode.trim())}}
                                      </a>
                                    </ng-container>
                                  </h4>
                                  <p class="game-name-bottom">{{game.GameCode?translateService.instant(game.GameCode) :
                                    game.Name}}
                                    <a (click)="fav(game, false)" *ngIf="CheckFevGame(game.GameCode.trim())">
                                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"
                                        fill="red">
                                        <path
                                          d="M12 4.435c-1.989-5.399-12-4.597-12 3.568 0 4.068 3.06 9.481 12 14.997 8.94-5.516 12-10.929 12-14.997 0-8.118-10-8.999-12-3.568z" />
                                      </svg>
                                    </a>
                                    <a (click)="fav(game, true)" *ngIf="!CheckFevGame(game.GameCode.trim())">
                                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"
                                        fill="white">
                                        <path
                                          d="M12 9.229c.234-1.12 1.547-6.229 5.382-6.229 2.22 0 4.618 1.551 4.618 5.003 0 3.907-3.627 8.47-10 12.629-6.373-4.159-10-8.722-10-12.629 0-3.484 2.369-5.005 4.577-5.005 3.923 0 5.145 5.126 5.423 6.231zm-12-1.226c0 4.068 3.06 9.481 12 14.997 8.94-5.516 12-10.929 12-14.997 0-7.962-9.648-9.028-12-3.737-2.338-5.262-12-4.27-12 3.737z" />
                                      </svg>
                                    </a>
                                  </p>
                                </div>
                              </ng-container>
                            </swiper>
                          </div>
                        </div>
                      </ng-container>
                      <div class="row">
                        <p class="col-12 p-0 order-title">
                          <span class="order-name">{{"AllGames" | translate}}</span>
                          <span class="see-all cursor-pointer"> {{('SeeAll' | translate) }}
                            <span class="see-all-arrow"> {{'>'}} </span>
                          </span>
                        </p>
                        <div class="grid p-0 row">
                          <swiper [config]="config">
                            <ng-container *ngFor="let item of constant.tmpGameList;let i = index;">
                              <div class="swiper-slide effect-lexidiv" [value]="item.GameCode">
                                <figure class="effect-lexi"
                                  [style.backgroundImage]="'url('+ item.ImagePath +'),url(https://images.supernowa.net/Document/123/SN1.gif)'"
                                  [attr.title]="item.Name" [attr.alt]="item.Name">
                                </figure>
                                <a class="play-now"
                                  (click)="selectedfiterType===fiterType.WidGetGame? getGameUrl(item,0): NavigatoToGame(item,i)">{{'PlayNow'
                                  | translate}}</a>
                                <h4 class="d-flex justify-content-evenly last-result"
                                  *ngIf="item.GameResult !==  undefined && item.GameResult !== null && item.GameResult.length > 0 ">
                                  <!-- <a class="col" *ngFor="let result of item.GameResult">{{WinnerName(result,
                                    item.GameCode.trim())}}</a> -->

                                  <ng-container *ngFor="let result of item.GameResult;let i = index;">
                                    <a class="col" *ngIf="CheckGameResult(item.GameCode.trim(),i)">
                                      {{WinnerName(result, item.GameCode.trim())}}
                                    </a>
                                  </ng-container>
                                </h4>

                                <p class="game-name-bottom">{{item.GameCode?translateService.instant(item.GameCode) :
                                  item.Name}}
                                  <a (click)="fav(item, false)" *ngIf="CheckFevGame(item.GameCode.trim())">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"
                                      fill="red">
                                      <path
                                        d="M12 4.435c-1.989-5.399-12-4.597-12 3.568 0 4.068 3.06 9.481 12 14.997 8.94-5.516 12-10.929 12-14.997 0-8.118-10-8.999-12-3.568z" />
                                    </svg>
                                  </a>
                                  <a (click)="fav(item, true)" *ngIf="!CheckFevGame(item.GameCode.trim())">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"
                                      fill="white">
                                      <path
                                        d="M12 9.229c.234-1.12 1.547-6.229 5.382-6.229 2.22 0 4.618 1.551 4.618 5.003 0 3.907-3.627 8.47-10 12.629-6.373-4.159-10-8.722-10-12.629 0-3.484 2.369-5.005 4.577-5.005 3.923 0 5.145 5.126 5.423 6.231zm-12-1.226c0 4.068 3.06 9.481 12 14.997 8.94-5.516 12-10.929 12-14.997 0-7.962-9.648-9.028-12-3.737-2.338-5.262-12-4.27-12 3.737z" />
                                    </svg>
                                  </a>
                                </p>
                              </div>
                            </ng-container>
                          </swiper>
                        </div>
                        <!-- <div class="grid p-0 row">
                          <div class="col-sm-3 col-xl-2 col-6" *ngFor="let item of constant.tmpGameList;let i = index;">
                            <figure class="effect-lexi"
                              [style.backgroundImage]="'url('+ item.ImagePath +'),url(https://images.supernowa.net/Document/123/SN1.gif)'"
                              (click)="selectedfiterType===fiterType.WidGetGame? getGameUrl(item,0): NavigatoToGame(item,i)">
                              <figcaption>
                                <p> <a class="play-now">{{'PlayNow' | translate}}</a> </p>
                              </figcaption>
                            </figure>
                          </div>
                        </div> -->
                        <!-- <div class="col-sm-3 col-xl-2 col-6 " routerLink="/{{item.key}}"
                          *ngFor="let item of constant.tmpGameList;let i = index;" style="cursor: pointer;"
                          title="{{item.Name}}">
                          <div class="box backgroundImage"
                            [style.backgroundImage]="'url('+ item.ImagePath +'),url(https://images.supernowa.net/Document/123/SN1.gif)'"
                            (click)="selectedfiterType===fiterType.WidGetGame? getGameUrl(item,0): NavigatoToGame(item,i)">
                            <div class="middle">
                              <a  class="cb-btn-deposit">{{'PlayNow' | translate}}</a>
                            </div>
                          </div>
                        </div> -->
                        <!-- <div class="col-sm-3 col-xl-2 col-6 " routerLink="/{{item.key}}"
                          *ngFor="let item of constant.tmpGameList;let i = index;" style="cursor: pointer;"
                          title="{{item.Name}}" > -->
                        <!-- <div class="game-box"
                            [style.backgroundImage]="'url('+ item.ImagePath +'),url(https://images.supernowa.net/Document/123/SN1.gif)'"
                            (click)="selectedfiterType===fiterType.WidGetGame? getGameUrl(item,0): NavigatoToGame(item,i)">
                            <div class="middle">
                              <a class="cb-btn-deposit">{{'PlayNow' | translate}}</a>
                            </div>
                          </div> -->
                        <!-- </div> -->
                      </div>
                      <!-- <div class="row p-0 d-flex justify-content-center">
                        <div class="imgonly" *ngFor="let item of constant.tmpGameList;let i = index;">
                          <div class="imgonly-items">
                            <div class="game-info">
                              <img class="w-100" src="{{item.ImagePath}}" alt="">
                            </div>
                          </div>
                        </div>
                      </div> -->
                      <!-- <div class="row p-0 d-flex justify-content-center">
                        <ng-container *ngFor="let item of constant.tmpGameList;let i = index;">
                      
                          <div class="port-content" title="{{item.Name}}">
                            <div title="{{item.Name}}"
                              (click)="selectedfiterType===fiterType.WidGetGame? getGameUrl(item,0): NavigatoToGame(item,i)">
                              <div class="port-inner">
                                <div class="thumb">
                                  <a class="cursor-pointer text-decoration-none" routerLink="/{{item.key}}">
                                    <div class="cb-game-thumbnail">
                                      <div class="image">
                                        <img
                                          src="https://images.supernowa.net/Document/GameImages/b9ad7a41e5824823bade7dd83121e5db_Poker.jpg"
                                          alt="">
                                        <img src="{{item.ImagePath}}" alt="">
                                        <h3>{{item.GameCode?translateService.instant(item.GameCode) : ''}}
                                        </h3>
                                      </div>
                                    </div>
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>
                        </ng-container>
                      </div> -->
                    </div>
                    <div class="col-12 col-sm-12 p-0 portfolio singleview"
                      [hidden]="selectedfiterType === fiterType.All">
                      <div class="grid p-0 row ">
                        <div class="col-sm-3 col-6 swiper-slide effect-lexidiv big-screen5"
                          *ngFor="let item of constant.tmpGameList;let i = index;">
                          <figure class="effect-lexi"
                            [style.backgroundImage]="'url('+ item.ImagePath +'),url(https://images.supernowa.net/Document/123/SN1.gif)'"
                            
                            [attr.title]="item.Name" [attr.alt]="item.Name">
                            <!-- <figcaption>
                              </figcaption> -->
                          </figure>
                          <a class="play-now" (click)="selectedfiterType===fiterType.WidGetGame? getGameUrl(item,0): NavigatoToGame(item,i)">{{'PlayNow' | translate}}</a>
                          <h4 class="d-flex justify-content-evenly last-result"
                            *ngIf="item.GameResult !==  undefined && item.GameResult !== null && item.GameResult.length > 0 ">
                            <!-- <a class="col" *ngFor="let result of item.GameResult">{{WinnerName(result,
                              item.GameCode.trim())}}</a> -->
                            <ng-container *ngFor="let result of item.GameResult;let i = index;">
                              <a class="col" *ngIf="CheckGameResult(item.GameCode.trim(),i)">
                                {{WinnerName(result, item.GameCode.trim())}}
                              </a>
                            </ng-container>
                          </h4>
                          <p class="game-name-bottom m-0">{{item.GameCode?translateService.instant(item.GameCode) :
                            item.Name}}
                            <a (click)="fav(item, false)" *ngIf="CheckFevGame(item.GameCode.trim())">
                              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"
                                fill="red">
                                <path
                                  d="M12 4.435c-1.989-5.399-12-4.597-12 3.568 0 4.068 3.06 9.481 12 14.997 8.94-5.516 12-10.929 12-14.997 0-8.118-10-8.999-12-3.568z" />
                              </svg>
                            </a>
                            <a (click)="fav(item, true)" *ngIf="!CheckFevGame(item.GameCode.trim())">
                              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"
                                fill="white">
                                <path
                                  d="M12 9.229c.234-1.12 1.547-6.229 5.382-6.229 2.22 0 4.618 1.551 4.618 5.003 0 3.907-3.627 8.47-10 12.629-6.373-4.159-10-8.722-10-12.629 0-3.484 2.369-5.005 4.577-5.005 3.923 0 5.145 5.126 5.423 6.231zm-12-1.226c0 4.068 3.06 9.481 12 14.997 8.94-5.516 12-10.929 12-14.997 0-7.962-9.648-9.028-12-3.737-2.338-5.262-12-4.27-12 3.737z" />
                              </svg>
                            </a>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  </ng-container>
  <ng-container *ngIf="(this.constant.isLobbyShowLive == false) || (this.constant.isLobbyShowVirtual == false)">
    <p>{{'Invalid Token. Please Login Again' | translate}}</p>
  </ng-container>
</ng-container>
<app-error *ngIf="!constant.IsVerified" [errorMessage]="displayMessage" [navigateLink]="constant.LoginLink"></app-error>
<app-view-skeleton [name]="'lobby'" *ngIf="constant.isLobbyShow"></app-view-skeleton>